import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import React from 'react';

import GeneralCarousel from '../general_carousel/GeneralCarousel';

import { IProduct } from './IProduct';
import PdpDescriptionArea from './PdpDescription';
import PdpGallery from './PdpGallery';

import '../pdp_details/PdpDetailAccordion.script';

export interface PdpProps {
    productData: IProduct;
}

const Pdp = ({ productData }: PdpProps) => {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                cacheTime: 1000 * 60 * 60 * 24, // 24 hours
                staleTime: Infinity,
            },
        },
    });
    const persister = createSyncStoragePersister({
        storage: window.localStorage,
    });
    return (
        <>
            <PersistQueryClientProvider client={client} persistOptions={{ persister }}>
                {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                <PdpGallery productData={productData} />
                <PdpDescriptionArea productData={productData} />
                <GeneralCarousel />
            </PersistQueryClientProvider>
        </>
    );
};

export default Pdp;
